import { v4 as uuidv4 } from 'uuid';

function clearIndustryFilters() {
    this.search.industryFilters = [];
    this.observed.search = uuidv4();
    this.applyDirectoryFilter();
}

export default clearIndustryFilters;
